export default __webpack_public_path__ + "media/Beverage-Soft-Drink.e02dde01.png";